import { render, staticRenderFns } from "./LoginOld.vue?vue&type=template&id=cb327e72&scoped=true"
import script from "./LoginOld.vue?vue&type=script&lang=js"
export * from "./LoginOld.vue?vue&type=script&lang=js"
import style0 from "./LoginOld.vue?vue&type=style&index=0&id=cb327e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb327e72",
  null
  
)

export default component.exports